import React, { useEffect, useState } from 'react';
import { MdUpload } from 'react-icons/md';
import { getCoursePageList, editCoursePageList } from 'Services/allApi';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CourseSeoPage from './CourseSeoPage';

function CoursePage() {
    const [formData, setFormData] = useState({
        heading: '',
    });
    const [imagePreview, setImagePreview] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [courseId, setCourseId] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getCoursePageList();
                console.log(response);
                const result = response.data;

                if (result) {
                    setFormData({ heading: result.heading || '' });
                    setImagePreview(result['bg_img'] || '');
                    setCourseId(result.id);
                } else {
                    setError('No course data found.');
                }
            } catch (err) {
                console.error(err);
                setError('Failed to fetch course data. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
                alert('Only JPEG, PNG, and GIF files are allowed.');
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                alert('File size must be less than 5MB.');
                return;
            }
            setImageFile(file);
            const reader = new FileReader();
            reader.onload = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUpdate = async () => {
        if (!formData.heading) {
            toast.error("Heading is missing");
            return;
        }

        const updatedData = new FormData();
        updatedData.append('heading', formData.heading);

        if (imageFile) {
            updatedData.append('bg_img', imageFile);
        }

        if (!courseId) {
            setError('Course ID is missing.');
            return;
        }

        try {
            const response = await editCoursePageList(courseId, updatedData);
            if (response.error) {
                setError(response.message);
                toast.error('Failed to update course data. Please try again.');
            } else {
                console.log('Course page updated successfully:', response);
                toast.success('Course page updated successfully!');
            }
        } catch (err) {
            console.error('Error updating course page:', err);
            setError('Failed to update course data. Please try again.');
            toast.error('Failed to update course data. Please try again.');
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <span className="loader">Loading...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="max-w-6xl mx-auto mt-5 p-4 bg-red-100 text-red-800 rounded-md">
                <strong>Error:</strong> {error}
            </div>
        );
    }

    return (
        <>
            <CourseSeoPage />
            <div className="max-w-8xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
                <h2 className="text-center text-3xl font-bold mb-5 mt-2">Course Page</h2>
                <hr className="mb-4" />

                <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
                    <div className="sm:col-span-2">
                        <label htmlFor="heading" className="block font-medium text-gray-900">
                            Heading
                        </label>
                        <div className="mt-2">
                            <input
                                name="heading"
                                id="heading"
                                value={formData.heading || ''}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
                        <div className="sm flex justify-center mb-4 sm:mb-0">
                            {imagePreview && (
                                <div className="max-w-full max-h-64">
                                    <img
                                        src={imagePreview}
                                        alt="Image Preview"
                                        className="w-full rounded shadow-md"
                                        style={{ height: '130px' }}
                                    />
                                </div>
                            )}
                            <div className="sm text-center">
                                <label htmlFor="bg_image" className="block font-medium text-gray-900 mb-2">
                                    Image
                                </label>
                                <input
                                    type="file"
                                    id="bg_image"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleImageUpload}
                                />
                                <button
                                    type="button"
                                    onClick={() => document.getElementById('bg_image').click()}
                                    className="px-4 py-2 ms-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                >
                                    <MdUpload />
                                </button>
                                <p className="mt-2 ms-3" style={{ fontSize: '10px' }}>The height and width must be </p>
                                <p className="mt-1 ms-2" style={{ fontSize: '10px' }}>1380 × 460</p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="mt-5 mb-5" />
                <div className="flex justify-center">
                    <button
                        type="button"
                        onClick={handleUpdate}
                        className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                    >
                        Update
                    </button>
                </div>
                <ToastContainer position="top-center" autoClose={5000} />
            </div>
        </>
    );
}

export default CoursePage;
